module.exports = __webpack_public_path__ + "img/DSC01179.9ca42f1f.jpg";